import _ from 'lodash';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MDBDropdownService {

    constructor(
    ) { }

    getHTML(id: string, list: any[], options?: any) {
        const select = document.createElement('select');
        select.id = id;
        select.className = 'select-wrapper mdb-select mdb-select--paybee';

        const multiple = _.get(options, 'miltiple', false);
        if(multiple) {
            select.setAttribute('multiple', null);
        }

        const searchable = _.get(options, 'searchable', null);
        if(_.isString(searchable)) {
            select.setAttribute('searchable', searchable);
        }

        const getId = _.get(options, 'getId', ({ id }) => id);
        const getName = _.get(options, 'getName', ({ name }) => name);
        const result = _.map(list, (element) => {
            let id = getId(element);
            let name = getName(element);

            if(options.additionalInfoSelectList){
                name = element
                id = element
            }
            
            const amount = element.amount
            let disabled = false
            if(element.soldOut){
                disabled = element.soldOut
                return `<option disabled="${disabled}" value="${id}">${name} ${ amount > 0 ? `($${amount})`: '' } - Sold Out</option>`;
            }
            return `<option value="${id}">${name} ${ amount > 0 ? `($${amount})`: '' }</option>`;
        });
        result.unshift("<option disabled>Select One</option>");

        select.innerHTML = result.join("");
        return select.outerHTML;
    }
}
